import { Modal, AutoComplete, Form, Switch, Space, message, Input, Select } from 'antd';
import type { InputRef } from 'antd';
import { useState, useEffect, useMemo, useRef } from 'react';
import { QAItem } from '../components/productQA-item';
import { request } from '@/utils/request';
import useFetch from '@/hooks/useFetch';
import styles from '../index.less';
import { ExpandOutlined, CompressOutlined } from '@ant-design/icons';

type PersonalPrompt = { remark: string; value: string; label: string; id: string; }

const usePrompt = () => {
  const [form] = Form.useForm();
  const { data, fetchData: fetchPrompt } = useFetch('/local/knowledge/personalPrompt', {});
  const [qaList, setQaList] = useState<QAItem[]>([]);
  const [type, setType] = useState<string | null>(null);
  const [bigTextArea, setBigTextArea] = useState<boolean>(false);
  const [prompt, setPrompt] = useState<string>("");
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
  }, [qaList]);

  const typeList: string[] = useMemo(() => {
    if (!data) return [];
    return Array.from(new Set(data.filter((vo: PersonalPrompt) => Boolean(vo.remark)).map((vo: PersonalPrompt) => vo.remark)))
  }, [data]);

  const promptList = useMemo(() => {
    if (!type) return data;
    return data.filter((item: PersonalPrompt) => item.remark === type);
  }, [type, data])

  const handleOk = async () => {
    const formValue = await form.validateFields();
    const { resp, error } = await request('/local/knowledge/productQA/generate_answer', {
      method: "POST",
      data: {
        qas: qaList.map(item => ({ rowId: item.id, question: item.question })),
        ...formValue
      }
    });
    if (resp?.code !== 0) return message.error(error?.message);
    message.success(resp?.message);
    clear();
    if (formValue.createPrompt) fetchPrompt();
  }

  const clear = () => {
    setQaList([]);
  }

  return {
    E: <div>
      <Modal
        visible={qaList.length > 0}
        width={1000}
        title="利用提示词生成回答"
        onOk={handleOk}
        onCancel={clear}
      >
        <Form form={form} initialValues={{ createPrompt: true, prompt: "" }}>
          <Form.Item label="根据备注筛选提示词">
            <Select
              allowClear
              placeholder="可选择具体备注来筛选提示词，不选择则全部展示"
              value={type}
              onChange={(value: string) => setType(value)}
              showSearch
              filterOption={(input, option) =>
                (option?.key ?? '').includes(input)
              }
            >
              {
                typeList.map((t: string) => <Select.Option value={t} key={t}>{t}</Select.Option>)
              }

            </Select>
          </Form.Item>
          <div style={{ position: 'relative' }}>
            <Form.Item label="提示词" name="prompt" rules={[{ required: true }]}>
              <AutoComplete
                options={promptList}
                filterOption={(inputValue, option) => {
                  return (option?.label as string).includes(inputValue);
                }}
                maxLength={5000}
              >
                <Input.TextArea
                  showCount
                  autoSize={{ minRows: 10, maxRows: 10 }}
                  className={styles.promptTextArea}
                  placeholder="请输入提示词（最多5000字符）"
                  allowClear
                />
              </AutoComplete>
            </Form.Item>
            <a
              style={{ position: 'absolute', right: 30, top: 3, zIndex: 100, padding: 0, margin: 0, }}
              onClick={() => {
                setPrompt(form.getFieldValue("prompt"));
                setBigTextArea(true);
                setTimeout(() => inputRef.current!.focus({
                  cursor: 'end',
                }), 300)
              }}
            ><ExpandOutlined /></a>
          </div>


          <Form.Item label="提示词备注" name="remark">
            <Input placeholder="该提示词的使用说明" allowClear />
          </Form.Item>
          <Form.Item label="保存该提示词" name="createPrompt" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>

        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {
            qaList.length > 0 && <Space direction="vertical">
              <h3>需要生成回答的问题：</h3>
              {
                qaList.filter((item, index) => index < 5).map((item, index) => <div key={item.id}>{index + 1}、{item.question}</div>)
              }
              {qaList.length > 5 ? <>...</> : <></>}
              <h4>注：无操作权限的问题会被剔除！</h4>
            </Space>
          }
        </div>
      </Modal>
      <Modal
        wrapClassName={styles.previewModal}
        visible={bigTextArea}
        width={'100vw'}
        footer={false}
        style={{ padding: 0, margin: 0, top: 0, pointerEvents: 'auto' }}
        modalRender={() => <div style={{ width: '100vw', height: '100vh', background: 'rgba(0, 0, 0, 0.85)', position: 'relative' }}>
          <Input.TextArea
            style={{ height: '100%', background: 'transparent', color: '#fff', fontSize: 20, paddingTop: 20 }}
            onChange={e => {
              setPrompt(e.target.value);
              form.setFieldsValue({ prompt: e.target.value });
            }}
            value={prompt}
            maxLength={5000}
            ref={inputRef}
          />
          <a
            style={{ position: 'absolute', right: 12, top: 7, fontSize: 24 }}
            onClick={() => setBigTextArea(false)}><CompressOutlined /></a>
        </div>}
      />
    </div>,
    controller: {
      setQaList
    }
  }
}

export default usePrompt;